<template>
  <div>
    <vs-alert
      v-for="(message, index) in replacementDetails.resultMessages"
      :key="`message-${index}`"
      class="mb-3"
      active="true"
      :color="message.type === 'ok' ? 'success' : 'danger'"
      :icon="message.type === 'ok' ? 'done_outline' : 'error_outline'"
    >
      <span>{{ message.result || "" }}</span>
    </vs-alert>
    <div class="vx-row">
      <div class="vx-col mt-6 w-2/5">
        <vx-card title="Order Details">
          <vs-table data="_">
            <vs-tr>
              <vs-td>Order Number:</vs-td>
              <vs-td>{{replacementDetails.order_number || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Name:</vs-td>
              <vs-td>{{replacementDetails.name || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Email:</vs-td>
              <vs-td>{{replacementDetails.email || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Created At:</vs-td>
              <vs-td>{{replacementDetails.created_at || ""}}</vs-td>
            </vs-tr>
          </vs-table>
        </vx-card>
      </div>
      <div class="vx-col mt-6 w-3/5">
        <vx-card title="Shipping Info">
          <vs-table data="_">
            <vs-tr>
              <vs-td>Address 1:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.address1 || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Address 2:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.address2 || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>City:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.city || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Zip:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.zip || ""}}</vs-td>
            </vs-tr>
            <vs-tr v-if="replacementDetails.shipping_address.state.length">
              <vs-td>State:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.state}}</vs-td>
            </vs-tr>
            <vs-tr v-if="replacementDetails.shipping_address.province.length">
              <vs-td>Province:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.province}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Country:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.country || ""}}</vs-td>
            </vs-tr>
            <vs-tr v-if="replacementDetails.shipping_address.country_code.length">
              <vs-td>Country Code:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.country_code}}</vs-td>
            </vs-tr>
            <vs-tr v-if="replacementDetails.shipping_address.province_code.length">
              <vs-td>Province Code:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.province_code}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Phone:</vs-td>
              <vs-td>{{replacementDetails.shipping_address.phone || ""}}</vs-td>
            </vs-tr>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <vs-button class="mt-5" @click="close()">Done</vs-button>
  </div>
</template>

<script>
  export default {
    props: [
      'next',
      'replacementDetails'
    ],
    methods: {
      close() {
        this.$emit('update:replacementDetails', null);
        this.next(true)
      }
    }
  }
</script>
